<mat-card>
  <mat-card-content>
    <ui-order-addresses [customer]="customer()"></ui-order-addresses>
    <div class="row">
      <div class="row-item">
        <ui-order-delivery [deliveryDate]="deliveryDate()"></ui-order-delivery>
      </div>
      <div class="row-item">
        <ui-order-payment></ui-order-payment>
      </div>
      @if (orderCustomReferenceText()) {
        <div class="row-item">
          <ui-order-checkout-reference-text [orderCustomReferenceText]="orderCustomReferenceText()"></ui-order-checkout-reference-text>
        </div>
      }
    </div>
  </mat-card-content>
</mat-card>
